module.exports = __webpack_public_path__ + "static/img/hugonghuli2.c8ccd7ba.png";